import { DashboardRouter } from "../dashboard.router";

export class GuideRouter {
    
    static getRoute(): string {
        return `${DashboardRouter.getRoute()}/user-guide`
    }

}